import { ReactNode } from 'react';
import classNames from 'classnames/bind';
import styles from './Layout.module.scss'

const cn = classNames.bind(styles);

type LayoutProps = {
    children: ReactNode;
    footer?: ReactNode;
};


const Layout = ({ children, footer }: LayoutProps): JSX.Element => (
    <div  className={cn('layout')}>
        <main className={cn('layout__main')}>{children}</main>
        {footer}
    </div>
);

export default Layout;

